import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_CARDS,
    GET_CHARITY_DETAILS,
    GET_CHARITY_DETAILS_BY_ID,
} from './justTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_CARDS: {
            return {
                ...state,
                all_cards: action.payload,
            }
        }
        case GET_CHARITY_DETAILS: {
            return {
                ...state,
                all_charity_details: action.payload,
            }
        }
        case GET_CHARITY_DETAILS_BY_ID: {
            return {
                ...state,
                all_charity_details_by_id: action.payload,
            }
        }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
